"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Icon = ({
  isChatOpened,
  loading
}) => {
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Progress, {
      size: 26
    });
  }
  return isChatOpened ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CloseIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OpenIcon, {});
};
exports.Icon = Icon;
